module.exports = __webpack_public_path__ + "media/laws-bg2-1920.08ae3908.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/laws-bg2-1920.jpg
// module id = 1350
// module chunks = 57